import { initMiniCart } from "./product-recommendation.js";

const isLoading = false;

function validateZipCode(elementValue) {
  var zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
  return zipCodePattern.test(elementValue);
}

function processSubmission() {
  setLoading(true);
  var errorMessage = jQuery(".error-message");
  var inputContainer = jQuery(".input-container");
  errorMessage.text("");
  inputContainer.removeClass("border");
  var zipcode = document.querySelector("input#zip").value;
  var isValidZip = validateZipCode(zipcode);
  if (!isValidZip) {
    console.log("invalid zipp");
    inputContainer.addClass("border");
    errorMessage.text("Invalid ZIP entered.");
    return;
  }
  var url =
    "https://www.storemapper.co/api/v2/stores/search?user_id=3148&access_token=0deeda0b22b4be1b3af2233d11ec9bc6&near=" +
    zipcode +
    "&radius=25&unit=mi";
  console.log("zipcode", zipcode);
  console.log("run zip search", zipcode);
  $.get(url, function(data) {
    console.log("returned data", data);
    setResults(data);
    setLoading(false);
  }).fail(function(data) {
    console.log("an error happened");
    errorMessage.text(
      "There was an error processing your request. Please try again in a few minutes."
    );
    setResults();
    setLoading(false);
  });
}

function setLoading(status) {
  var submitBtn = $(".zip-search");
  var zipInput = $(".input-container");
  if (status) {
    console.log("loading...");
    submitBtn.text("Searching...");
    submitBtn.addClass("pointer-events-none");
    zipInput.addClass("pointer-events-none");
  } else {
    console.log("done loading...");
    submitBtn.text("Search");
    submitBtn.removeClass("pointer-events-none");
    zipInput.removeClass("pointer-events-none");
  }
}

function setResults(data) {
  var resultsHtml = "";
  console.log(typeof data.stores);
  var resultsContainer = $(".search-results");
  resultsContainer.html("");
  if (data.stores) {
    for (i = 0; i < data.stores.length; i++) {
      var store = data.stores[i];
      var name = store.name;
      var address = store.address;
      var html = `<div class="mb-2 border-b"><p class="result-title underline font-display cursor-pointer">${store.name}</p><p class="result-address text-sm">${store.address}</p></div>`;
      resultsHtml += html;
    }
    var finalhtml = $(resultsHtml);
    resultsContainer.html(finalhtml);
    $(".result-title").on("click", function() {
      var clickedStoreName = $(this).text();
      var clickedStoreAddress = $(this)
        .next()
        .text();
      console.log(clickedStoreName, clickedStoreAddress);
      CartJS.setAttribute("Supported Store Name", clickedStoreName);
      CartJS.setAttribute("Supported Store Address", clickedStoreAddress);
      console.log("clicked result title, should add note");
      var endHtml = $(
        `<div>Thank you for supporting your local boutique.</div>`
      );
      resultsContainer.html(endHtml);
      resultsContainer.addClass("p-4");
    });
  } else {
    resultsHtml = $(
      `<div class="text-sm">While there is not a local boutique selling enewton within a 25-mile radius of you, rest assured that 20% of your purchase will support our SHOP LOCAL initiative.</div>`
    );
    resultsContainer.html(resultsHtml);
    CartJS.setAttribute("Supported Store Name", "N/A - any store");
    CartJS.setAttribute("Supported Store Address", "N/A - any store");
  }
}

function checkGiftWrap (){
  var giftWrappedItems = 0;
  var giftCharges = 0;

  if ( CartJS.cart === undefined) return
  CartJS.cart.items.map(item => {
    if (item.variant_id == "31219870466082") {
      giftCharges += item.quantity;
    } else if (item.properties.giftWrap === "true") {
      console.log("found giftwrapped items");
      giftWrappedItems += item.quantity;
    }
  })

  if (giftWrappedItems > 0) {
    if (giftWrappedItems < giftCharges) {
      var difference = giftCharges - giftWrappedItems;
      CartJS.updateItemById(31219870466082, difference);
    } else if (giftWrappedItems > giftCharges) {
      var difference = giftWrappedItems - giftCharges;
      CartJS.addItem(31219870466082, difference);
    }
  } else if (giftWrappedItems === 0 && giftCharges > 0) {
    CartJS.removeItemById(31219870466082);
  }
  if (typeof Cookies.get("gwp") !== "undefined") {
    if (CartJS.cart.items_subtotal_price >= 5000) {
      var containsFreeGift = false;
      for (let i = 0; i < CartJS.cart.items.length; i++) {
        var item = CartJS.cart.items[i];
        if (item.id == 31224136433698) {
          containsFreeGift = true;
        }
      }
      if (!containsFreeGift) {
        CartJS.addItem(31224136433698);
      }
    } else if (CartJS.cart.items_subtotal_price < 5000) {
      var containsFreeGift = false;
      for (let i = 0; i < CartJS.cart.items.length; i++) {
        var item = CartJS.cart.items[i];
        if (item.id == 31224136433698) {
          containsFreeGift = true;
        }
      }
      if (containsFreeGift) {
        CartJS.removeItemById(31224136433698);
      }
    }
  } else if (typeof Cookies.get("gwp") === "undefined") {
    for (let i = 0; i < CartJS.cart.items.length; i++) {
      var item = CartJS.cart.items[i];
      if (item.id == 31224136433698) {
        CartJS.removeItemById(31224136433698);
      }
    }
  }
}

function updateMiniCart(cart){
  let miniCartContainer = document.querySelector(".mini-cart"),
      miniCartItem = document.querySelector(".mini-cart__item");
  // clears mini cart
  miniCartContainer.innerHTML = ""

  // rebuild minicart with updated cart JSON
  cart.items.forEach((item, i) => {
    let div = document.createElement("div");
    div.innerHTML = miniCartItem.innerHTML
    div.classList.add("mini-cart__item")

    let img = div.querySelector(".mini-cart__img"),
        link = div.querySelector(".mini-cart__title a"),
        qty = div.querySelector(".mini-cart__qty");

    img.src = item.image
    qty.innerHTML = `x ${item.quantity}`
    link.href = item.url
    link.innerHTML = item.title

    miniCartContainer.append(div)
  });

}

function openAtcNotice(data, qty) {
  var body = jQuery("body");
  body.addClass("modal-active");
  let lineHtml = "";

  jQuery(".support-container").addClass("hidden");

  lineHtml += ` <div class="flex flex-row items-center mb-4">
      <div class="flex justify-start mb-2 sm:mb-0">
          <a href="${data.url}"><img src="${data.image}" alt="${
    data.title
  }" style="width: auto; max-height: 125px;" /></a>
      </div>
      <div class="text-left mx-5 w-3/4 product-info">
        <div class="mb-2 flex"><span class="hidden label md:block">Item:</span> <a href="${data.url}">${data.title}</a></div>
        <div class="mb-2 flex"><span class="label block">Quantity:</span> ${data.quantity}</div>
        <div class="mb-2 flex"><span class="label block">Price:</span>
          $${((data.price / 100) * data.quantity).toFixed(
            2
          )}
        </div>
      </div>
    </div>
  `;

  jQuery(".atc-notice .line-items").html(lineHtml);

  if (!jQuery(".atc-notice").hasClass("open")) {
    jQuery(".atc-notice-overlay").toggleClass(
      "opacity-0 opacity-50 pointer-events-none"
    );
    jQuery(".atc-notice").toggleClass("open");
    jQuery(".atc-notice").fadeIn(200, function() {
      console.log("done");
    });
  }

  initMiniCart(data)
}

function closeAtcNotice() {
  var body = jQuery("body");
  body.removeClass("modal-active");
  jQuery(".atc-notice-overlay").toggleClass(
    "opacity-0 opacity-50 pointer-events-none"
  );
  jQuery(".atc-notice").fadeOut(200, function() {
    jQuery(".atc-notice").addClass("hidden");
    jQuery(".atc-notice").toggleClass("open");
  });
}

function activeVariantSwitcher() {
  if (jQuery(this).hasClass(".selected")) {
    return;
  }
  var originalId = jQuery(this)
    .parent(this)
    .find(".swatch.selected")
    .attr("data-variant-id");
  jQuery(this)
    .parent(this)
    .find(".swatch.selected")
    .removeClass("selected");
  jQuery(this).addClass("selected");
  jQuery(`[data-cart-add="${originalId}"]`).attr(
    "data-cart-add",
    jQuery(this).attr("data-variant-id")
  );
  if (window.location.href.includes("/product")) {
    var pdpSlick = $(".slick-pdp").slick("getSlick");
    var index = jQuery(this).attr("index");
    console.log(index, pdpSlick.slideCount);
    if (index <= pdpSlick.slideCount) {
      jQuery(".slick-featured-desktop").slick("slickGoTo", index - 1);
      jQuery(".slick-pdp").slick("slickGoTo", index - 1);
    }
    jQuery("[data-current-variant]").text(
      jQuery(this).attr("data-variant-title")
    );
    jQuery("[data-variant-sku-display]").text(
      jQuery(this).attr("data-variant-sku")
    );
  } else if (window.location.href.includes("/collection")) {
  }
}

const initATC = () => {
  $(document).ready(function(){
    checkGiftWrap()
  })
  // add to cart updates
  jQuery(document).on("cart.requestComplete", function(event, cart) {
    jQuery(".cart-count").attr("data-before", cart.item_count);
    if (window.location.href.includes("/cart")) {
      checkGiftWrap()
      window.location.reload();
    } else if (cart.item_count == 0) {
      closeAtcNotice();
      $(".support-container").addClass("hidden");
    } else {
      updateMiniCart(cart)
      checkGiftWrap()
      $(".support-container").removeClass("hidden");
    }
  });

  jQuery(".atc-notice-overlay").on("click", function() {
    closeAtcNotice();
  });

  jQuery(".atc-notice .fa-times").on("click", function() {
    closeAtcNotice();
  });

  jQuery(".atc-notice span.close-atc-notice").on("click", function() {
    closeAtcNotice();
  });

  jQuery(".fa-bars").on("click", function(e) {
    e.preventDefault();
    jQuery(".mobile-mega-menu").toggleClass("hidden");
    jQuery("body").addClass("modal-active");
    jQuery(".search-container").addClass("hidden");
  });
  jQuery(".mobile-mega-menu i.fa-times").on("click", function(e) {
    jQuery(".mobile-mega-menu").addClass("hidden");
    jQuery("body").removeClass("modal-active");
  });

  jQuery("[data-variant-selector-swatch]").on("click", activeVariantSwitcher);
  jQuery("[data-variant-selector]").on("change", function(e) {
    var currentElement = e.target;
    var isSwatch = false;
    for (var i = 0; i < currentElement.attributes.length; i++) {
      if (
        currentElement.attributes[i].name === "data-variant-selector-swatch"
      ) {
        isSwatch = true;
      }
    }
    if (window.location.href.includes("/product") && !isSwatch) {
      var pdpSlick = $(".slick-pdp").slick("getSlick");
      var index = jQuery(this).attr("index");
      var option = jQuery("option:selected", this);
      console.log(option);
      console.log("selected");
      var index = option.attr("index");
      var variantId = option.attr("value");
      console.log(variantId);
      if (index <= pdpSlick.slideCount) {
        jQuery(".slick-featured-desktop").slick("slickGoTo", index - 1);
        jQuery(".slick-pdp").slick("slickGoTo", index - 1);
      }
      jQuery(".atc-btn").attr("data-product-id", variantId);
    }
  });

  $(".zip-search").on("click", function() {
    processSubmission();
  });
  $("input#zip").on("keypress", "input", function(e) {
    if (e.which === 13) {
      processSubmission();
    }
  });
  $(".input-container").on("keypress", "input", function(e) {
    if (e.which === 13) {
      processSubmission();
    }
  });
}

export {initATC, openAtcNotice}